var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ready)?_c('OnboardingRegisterHandler',{attrs:{"initial-value":_vm.model,"loading":_vm.loading},on:{"complete":_vm.onNext}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }